import replaceACFVariables from '../../js/utils/replaceACFVariables';

const replaceAcf = (acfGroups, { optionVariables }) => {
  const newACF = replaceACFVariables(acfGroups, optionVariables);
  return newACF;
};

export default replaceAcf;
